<template>
  <div class="ratio-edit">
    <p class="title">{{ ratioEditData ? '编辑任务' : '新建任务' }}</p>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" size="small">
      <el-form-item label="任务名称：" prop="alias">
        <el-input v-model="ruleForm.alias" type="text" show-word-limit maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="执行时间：" required>
        <el-col :span="11">
          <el-form-item prop="startHour" class="mb0">
            <el-time-select
              :disabled="!!ratioEditData"
              placeholder="起始时间"
              v-model="ruleForm.startHour"
              style="width: 100%;"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00'
              }">
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="2" style="text-align:center;">-</el-col>
        <el-col :span="11">
          <el-form-item prop="endHour" class="mb0">
            <el-time-select
              :disabled="!!ratioEditData"
              placeholder="结束时间"
              v-model="ruleForm.endHour"
              style="width: 100%;"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00'
              }">
            </el-time-select>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="重复周期：" required>
        <el-col :span="8">
          <el-form-item class="mb0">
            <el-checkbox-group v-model="doType" :disabled="!!ratioEditData">
              <el-checkbox label="按周循环" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="week" class="mb0">
            <el-select :disabled="!doType || !!ratioEditData" v-model="ruleForm.week" multiple placeholder="请选择">
              <el-option
                v-for="item in weekOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form-item>
    </el-form>
    <template v-if="ruleForm.startHour && ruleForm.endHour">
      <p class="label">选择站点：</p>
      <el-form :model="searchForm" ref="searchForm" label-width="100px" size="small">
        <el-form-item label="时间：">
          <el-date-picker
            style="width:100%;"
            v-model="searchForm.time"
            type="datetimerange"
            align="left"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="站点状态：">
          <el-col :span="13">
            <!-- 状态0:空桩,1:正常,2:满桩,3:偏多,4:偏少 -->
            <el-select v-model="searchForm.messageType" placeholder="请选择">
              <el-option
                v-for="item in messageTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="11">
            <el-button type="primary" @click="onSearchForm">查询</el-button>
            <el-button @click="resetSearchForm('searchForm')">重置</el-button>
          </el-col>
        </el-form-item>
      </el-form>
      <div style="text-align:right;margin-top:10px;">
        <el-input v-model="ratioNum" placeholder="输入满桩值" style="width:100px;margin-right:15px;" size="small"></el-input>
        <el-button @click="onFull" size="small">批量填充</el-button>
      </div>
      <div>
        <w-table
          v-loading.body="tableLoading"
          :data-list="tableData"
          :columns="ratioEditColumns"
          :bPagination="false"
          >
          <template slot-scope="props" slot="cell">
            <span v-if="props.column.label === '站点名称'">
              <span @click="showWindowPop(props.row)" style="cursor: pointer;">{{props.row.siteName}}</span>
            </span>
            <span v-else-if="props.column.label === '满桩值'">
              <el-input v-model="props.row.ratio" style="width:80px;" size="mini" type="number" min="0"  @input="validateInput(props.row)"></el-input>
            </span>
            <span v-else-if="props.column.label === '操作'">
              <el-button size="mini" @click="onDelPre(props.row)" type="text">删除</el-button>
            </span>
            <span v-else>{{ props.row[props.column.property]}}</span>
          </template>
        </w-table>
      </div>
    </template>
  </div>
</template>

<script>
import Api from '@/api'
import store from '@/store'
import WTable from '@/components/Table/index.vue'
import { ratioEditColumns } from './staticData.js'
export default {
  name: 'ratio-edit',
  props: ['ratioEditData', 'selfAreaId'],
  data() {
    return {
      ruleForm: {
        alias: '',
        startHour: '',
        endHour: '',
        week: ''
      },
      rules: {
        alias: [
          { required: true, message: '尚未输入任务名称！', trigger: 'blur' }
        ],
        startHour: [
          { required: true, message: '尚未选择开始执行时间！', trigger: 'blur' }
        ],
        endHour: [
          { required: true, message: '尚未选择结束执行时间！', trigger: 'blur' }
        ],
        week: [
          { required: true, message: '请选择重复周期！', trigger: 'blur' }
        ]
      },
      doType: '',
      weekOptions: [
        {
          value: 1,
          label: '星期一'
        }, {
          value: 2,
          label: '星期二'
        }, {
          value: 3,
          label: '星期三'
        }, {
          value: 4,
          label: '星期四'
        }, {
          value: 5,
          label: '星期五'
        }, {
          value: 6,
          label: '星期六'
        }, {
          value: 0,
          label: '星期日'
        }
      ],
      searchForm: {
        time: '',
        messageType: ''
      },
      // 状态0:空桩,1:正常,2:满桩,3:偏多,4:偏少
      messageTypeOptions: [
        {
          value: '',
          label: '全部'
        }, {
          value: 'empty',
          label: '空桩'
        }, {
          value: 'full',
          label: '满桩'
        }, {
          value: 'more',
          label: '偏多'
        }, {
          value: 'less',
          label: '偏少'
        }
      ],
      ratioNum: '',
      tableLoading: false,
      ratioEditColumns,
      tableData: []
    }
  },
  mounted() {
    if (this.ratioEditData) {
      this.initRatioEditData()
      this.getMagnifySite()
    } else {
      // 初始化 周期
      this.doType = true
      this.ruleForm.week = [1, 2, 3, 4, 5, 6, 0]
    }
  },
  methods: {
    showWindowPop(site) {
      this.$emit('showWindowPop', site)
    },
    checkParmas() {
      let type = 1
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          type = 2
          console.log(this.ruleForm)
        } else {
          type = 3
        }
      })
      return type
    },
    addTableData(item) {
      if (!this.tableData.find(it => it.siteId === item.siteId)) {
        this.tableData.unshift(item)
        store.commit('globalVariable/save', {
          key: 'ratioSites',
          value: this.tableData
        })
      }
    },
    onSure() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onSubmit()
        } else {
          return false
        }
      })
    },
    // 确定提交了
    onSubmit() {
      const params = {
        selfAreaId: this.selfAreaId
      }
      const data = {
        areaId: this.selfAreaId,
        startHour: this.ruleForm.startHour,
        endHour: this.ruleForm.endHour,
        week: this.getNumWeek(this.ruleForm.week),
        alias: this.ruleForm.alias,
        siteList: JSON.stringify(this.getTableData())
      }
      if (!this.ratioEditData) {
        Api.addMagnify(params, data)
          .then(res => {
            if (res.code === 200) {
              this.$message.success('任务创建成功！')
              this.$emit('onShowDialog', { type: 3, from: 'ratioEdit' })
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        data.id = this.ratioEditData.id
        Api.editMagnify(params, data)
          .then(res => {
            if (res.code === 200) {
              this.$message.success('任务编辑保存成功！')
              this.$emit('onShowDialog', { type: 3, from: 'ratioEdit' })
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    getTableData() {
      if (this.ratioEditData && this.ratioEditData.taskId) {
        this.tableData.forEach(item => {
          item.taskId = this.ratioEditData.taskId
        })
      }
      return this.tableData.map(item => {
        const temp = {
          siteId: item.siteId,
          ratio: item.ratio,
          taskId: item.taskId
        }
        return temp
      })
    },
    getNumWeek() {
      const arr = [0, 0, 0, 0, 0, 0, 0]
      this.ruleForm.week.forEach(i => {
        arr[i] = 1
      })
      return arr.join(',')
    },
    onCancel() {
      this.resetRuleForm()
    },
    resetRuleForm() {
      this.ruleForm.alias = ''
      this.ruleForm.startHour = ''
      this.ruleForm.endHour = ''
      this.ruleForm.week = ''
      this.doType = false
    },
    initRatioEditData() {
      this.ruleForm.alias = this.ratioEditData.alias
      this.ruleForm.startHour = this.ratioEditData.startHour
      this.ruleForm.endHour = this.ratioEditData.endHour
      this.ruleForm.week = this.getRuleFormWeek(this.ratioEditData.week)
      this.doType = true
    },
    getMagnifySite() {
      const params = {
        selfAreaId: this.selfAreaId,
        taskId: this.ratioEditData.taskId
      }
      Api.getMagnifySite(params)
        .then(res => {
          if (res.code === 200) {
            this.tableData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log('getMagnifySite', err)
        })
    },
    getRuleFormWeek(week) {
      const ws = week.split(',')
      const wsText = []
      for (let i = 0, len = ws.length; i < len; i++) {
        if (ws[i] === '1') {
          wsText.push(i)
        }
      }
      return wsText
    },
    onDelPre(item) {
      this.tableData.splice(this.tableData.findIndex(e => e.siteId === item.siteId), 1)
      store.commit('globalVariable/save', {
        key: 'ratioSites',
        value: this.tableData
      })
    },
    onFull() {
      if (!this.ratioNum) {
        this.$message({
          message: '请输入满桩值',
          type: 'error'
        })
        return
      }
      this.tableData.forEach(item => {
        item.ratio = this.ratioNum
      })
      store.commit('globalVariable/save', {
        key: 'ratioSites',
        value: this.tableData
      })
    },
    onSearchForm(formName) {
      this.$emit('searchMapFromRatio', this.searchForm)
    },
    resetSearchForm(formName) {
      this.searchForm.time = ''
      this.searchForm.messageType = ''
    },
    // 校验满桩值的输入值
    validateInput(row) {
      if (row.ratio < 0) {
        row.ratio = 0 // 满桩值的输入值不能为负数
      }
    }
  },
  components: {
    WTable
  }
}
</script>

<style lang="less">
.ratio-edit .el-form-item__label {
  text-align: left;
}
.ratio-edit .mb0, .ratio-edit .mb0.el-form-item {
  margin-bottom: 0;
}
// .ratio-edit .el-form-item {
//   margin-bottom: 15px;
// }
</style>

<style lang="less" scoped>
.ratio-edit {
  position: fixed;
  right: 0;
  width: 480px;
  height: calc(100% - 130px);
  background-color: #FFF;
  border-left-color: #EBEBEB;
  border-left-style: solid;
  border-left-width: 1px;
  padding: 15px;
  overflow-y: scroll;
  .title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    line-height: 1;
    margin-bottom: 15px;
  }
  .label {
    font-size: 14px;
    color: #333;
    line-height: 1;
    margin-bottom: 15px;
    padding-top: 15px;
    border-top: 1px solid #DDD;
  }
}
</style>
